import { type RefObject, useEffect, useEffectEvent, useState } from 'react';
import { type TextInputInstance, type TextInputKeyPressEvent } from 'react-native';

import isAppleDevice from '~/util/isAppleDevice';

export function isSearchShortcutPressed(event: TextInputKeyPressEvent & { key: unknown }): boolean {
  if (typeof event.key !== 'string') {
    return false;
  }

  return (
    event.key === 'k' &&
    (!!('metaKey' in event && event.metaKey) || !!('ctrlKey' in event && event.ctrlKey))
  );
}

export function useSearchInputFocus() {
  const [isInputFocused, setInputFocused] = useState(false);

  function handleInputFocus() {
    setInputFocused(true);
  }

  function handleInputBlur() {
    setInputFocused(false);
  }

  return {
    isInputFocused,
    handleInputFocus,
    handleInputBlur,
  };
}

export function useSearchShortcut(inputRef: RefObject<TextInputInstance | null>) {
  const isApple = isAppleDevice();

  const keyDownListener = useEffectEvent((event: KeyboardEvent) => {
    if (!(event.key === 'k' && (isApple ? event.metaKey : event.ctrlKey))) {
      return;
    }
    event.preventDefault();
    inputRef.current?.focus();
  });

  useEffect(() => {
    if (isApple === null) {
      return;
    }
    document.addEventListener('keydown', keyDownListener, false);
    return () => document.removeEventListener('keydown', keyDownListener);
  }, [isApple]);

  return isApple;
}
